import { useCallback, useMemo, useState } from 'react'
import { useReactiveVar } from '@apollo/client'
import { balanceVar } from 'shared/store/balance-store'
import { activeBalanceClaimSwitchTypeVar } from '../store/switch-types'
import { ClaimBalanceSwitchTypes } from '../types'
import { getClaimButtonTitle } from '../utils/get-claim-button-title'
import { getDepositButtonTitle } from '../utils/get-deposit-button-title'
import { useApproveBalanceFormSubmit } from './use-approved-balance-form-submit'

export const useApprovedBalanceForm = () => {
  const [inputValue, setInputValue] = useState('')
  const [isDisabledButton, setButtonDisabled] = useState(true)
  const { handleSubmit, loading } = useApproveBalanceFormSubmit()

  const activeType = useReactiveVar(activeBalanceClaimSwitchTypeVar)
  const balance = useReactiveVar(balanceVar)

  const handleChangeAmountValue = useCallback(
    (value: string) => {
      if (activeType === ClaimBalanceSwitchTypes.Deposit) {
        const maxWallet = balance.tokenBalance ?? 0
        setButtonDisabled(!value || Number(value) > maxWallet)
        return
      }

      if (activeType === ClaimBalanceSwitchTypes.Claim) {
        const treasuryBalance = balance.tokenDeposited
        setButtonDisabled(!value || Number(value) > treasuryBalance)
        return
      }

      setButtonDisabled(!value)
    },
    [activeType, balance]
  )

  const buttonTitle = useMemo(() => {
    if (inputValue === '') {
      return 'ENTER AMOUNT'
    }

    if (activeType === ClaimBalanceSwitchTypes.Claim) {
      return getClaimButtonTitle(inputValue, balance.tokenDeposited)
    }

    if (activeType === ClaimBalanceSwitchTypes.Deposit) {
      return getDepositButtonTitle(inputValue, balance.tokenBalance ?? 0)
    }

    return 'SUBMIT'
  }, [activeType, inputValue, balance])

  return {
    handleSubmit,
    loading,
    isDisabledButton,
    handleChangeAmountValue,
    buttonTitle,
    inputValue,
    setInputValue
  }
}
